export const changeMainWrapperPositionInPhone = ({
	position,
	mainWrapperRef,
	isPhone,
}) => {
	if (
		position == "fixed" &&
		mainWrapperRef.current &&
		mainWrapperRef.current?.style?.position !== "fixed" &&
		mainWrapperRef.current?.style?.height !== "100%" &&
		mainWrapperRef.current?.style?.minHeight !== "auto" &&
		isPhone
	) {
		mainWrapperRef.current.style.position = "fixed";
		mainWrapperRef.current.style.height = "100%";
		mainWrapperRef.current.style.minHeight = "auto";
	}
	if (
		position == "reset" &&
		mainWrapperRef.current &&
		mainWrapperRef.current?.style?.position == "fixed" &&
		mainWrapperRef.current?.style?.height == "100%" &&
		mainWrapperRef.current?.style?.minHeight == "auto" &&
		isPhone
	) {
		mainWrapperRef.current.style.position = null;
		mainWrapperRef.current.style.height = null;
		mainWrapperRef.current.style.minHeight = null;
	}
};
